import { render, staticRenderFns } from "./HotelSearch.vue?vue&type=template&id=a57dfaf4&"
import script from "./HotelSearch.vue?vue&type=script&lang=ts&"
export * from "./HotelSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports